import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=6c087fd5&"
import script from "./AdminMain.vue?vue&type=script&lang=ts&"
export * from "./AdminMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports